/* eslint-disable no-use-before-define */
import $ from 'jquery';
import 'slick-carousel';
import { gsap } from 'gsap';
// import useWheelTrigger from '@/js/components/useWheelTrigger';
import BaseComponent from './baseComponent';

export default class GoalBasedAdvisoryCarousel extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);

    this.$isOnOverview = true;
    this.$isVisible = false;
    this.$container = document.querySelector('[data-goal-based-advisory-container]');
    this.$appointmentButton = document.querySelector('button.-appointment');

    this.$pageHeader = document.querySelector('.page-header');
    this.$mainContent = document.querySelector('.main-content');

    if (this.$container) {
      this.$slidermask = document.querySelector('[data-goal-based-advisory-slidermask]');

      this.$slider = $('[data-goal-based-advisory-carousel]');
      this.$toHide = $('.heroelement');

      this.$cells = document.querySelectorAll('.goal-based-advisory-carousel-cell');
      this.$tl = gsap.timeline({ paused: true });

      this.$cells[0].classList.add('-first');

      this.$state = {
        isOverview: true,
      };

      this.$params = {};

      this.$sliderMaskPosition = this.sliderMaskPosition();
      this.$sliderMaskPosition.setMask(false);
    }

    this.addVisibilityObserver();
  }

  addVisibilityObserver() {
    const el = document.querySelector('.goal-based-advisory');

    if (!el) {
      return;
    }
    const options = {
      rootMargin: '0px',
      threshold: 0,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        this.onSliderIntersect(entry.isIntersecting);
        if (entry.isIntersecting) {
          this.$isVisible = true;
          el.classList.add('-intersecting');
        } else {
          el.classList.remove('-intersecting');
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(el);
  }

  onSliderIntersect(isIntersecting) {
    if (isIntersecting) {
      if (this.$appointmentButton) {
        this.$appointmentButton.classList.remove('-fixed');
      }
    } else if (this.$appointmentButton) {
      this.$appointmentButton.classList.add('-fixed');
    }
  }

  /**
   * Initialize the slider.
   */
  init() {
    if (!this.$container) {
      return;
    }

    this.$slider.slick({
      dots: true,
      infinite: false,
      fade: true,
      arrows: false,
      swipe: false,
    });

    this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (currentSlide >= this.$cells.length && nextSlide < 0) {
        return;
      }

      this.onSlideChange(currentSlide, nextSlide);

      const totalSlideCount = this.$cells.length;
      const isLastSlide = nextSlide + 1 >= totalSlideCount;

      if (isLastSlide) {
        this.unlockSlider();
      } else {
        this.lockSlider();
      }
    });

    $('.button.-prev').click(() => {
      this.$slider.slick('slickPrev');
    });

    $('.button.-next').click(() => {
      this.$slider.slick('slickNext');
    });

    $('.startslider').on('click', () => {
      // trigger.stop();

      this.$toHide.addClass('_hidden');
      this.$slider.addClass('_display-grid');
      this.$slider.slick('setPosition'); // refresh positioning of slick
      this.$slider.slick('slickGoTo', 0); // always start with the first slide

      this.enterSlider();

      // setTimeout(() => {
      this.$slider.addClass('-active');
      // }, 50);
    });

    // eslint-disable-next-line no-unused-vars,no-use-before-define
    // const trigger = useWheelTrigger(clickEnterSliderButton, {
    //   triggerY: 30,
    // });

    const endSliderButtons = Array.from(document.querySelectorAll('.endslider'));

    for (let i = 0; i < endSliderButtons.length; i += 1) {
      const btn = endSliderButtons[i];

      btn.addEventListener('click', () => {
        this.$isOnOverview = true;
        this.$toHide.removeClass('_hidden');
        this.$slider.removeClass('_display-grid');
        this.$slider.removeClass('-active');
        this.$slider.slick('slickGoTo', 0);

        this.leaveSlider();

        // setTimeout(() => {
        //   trigger.start();
        // }, 100);

        // document.addEventListener('click', function removeTrigger() {
        //   trigger.stop();
        //   document.removeEventListener('click', removeTrigger);
        // });
      });
    }

    function clickEnterSliderButton() {
      const buttonEnterSlider = document.querySelector('.startslider');

      if (buttonEnterSlider) {
        buttonEnterSlider.click();

        // trigger.stop();
      }
    }

    // button "überspringen" will only be visible after the second load of the page
    $(document).ready(() => {
      // unlock slider when clicking on "überspringen"
      $('.button.-skip').click(() => {
        // trigger.stop();

        clickEnterSliderButton();
        this.$slider.slick('slickGoTo', this.$cells.length); // show last slide on scroll-up

        const pageHeader = document.querySelector('.page-header');

        if (window.innerWidth >= 1200) {
          pageHeader?.classList.add('-is-hidden');
          pageHeader?.classList.add('-hidden-important');

          setTimeout(() => {
            pageHeader?.classList.add('-is-hidden');
            pageHeader?.classList.remove('-hidden-important');
          }, 1200);
        } else {
          pageHeader?.classList.remove('-is-hidden');
          pageHeader?.classList.add('-hidden-important');

          setTimeout(() => {
            pageHeader?.classList.remove('-hidden-important');
          }, 1200);
        }

        document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';
      });
    });
  }

  onSlideChange(oldSlideIndex, newSlideIndex = { delay: true }) {
    const cell = this.$cells[newSlideIndex];
    const oldCell = this.$cells[oldSlideIndex];

    if (cell) {
      const isBackwards = oldSlideIndex > newSlideIndex;

      if (isBackwards) {
        cell.classList.add('-active-back');
      } else {
        cell.classList.add('-active-forwards');
      }

      cell.classList.add('-active');

      this.setMaskForCell(cell, isBackwards);
    }

    if (oldCell) {
      oldCell.classList.remove('-active');
      oldCell.classList.remove('-active-back');
      oldCell.classList.remove('-active-forwards');
    }
  }

  unlockSlider() {
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    this.$pageHeader.classList.remove('-hidden-important');
    $('.button.-skip').addClass('_hidden');
    this.$pageHeader.classList.remove('-not-fixed');
    this.$pageHeader.classList.add('-is-hidden');

    if (window.innerWidth < 1200) {
      this.$pageHeader.classList.remove('-is-hidden');
    }
  }

  lockSlider() {
    document.documentElement.style.overflow = 'hidden';
    this.$pageHeader.classList.add('-hidden-important');
    $('.button.-skip').removeClass('_hidden');
    this.$pageHeader.classList.add('-not-fixed');
    this.$pageHeader.classList.add('-is-hidden');

    const compStyles = window.getComputedStyle(this.$mainContent);
    const compPaddingTop = compStyles.getPropertyValue('padding-top');
    const compPaddingTopInt = Number(compPaddingTop.replaceAll('px', ''));

    window.scrollTo({
      top: compPaddingTopInt,
      behavior: 'instant',
    });
  }

  setMaskForCell(cell, isBackwards) {
    const x = stringPercentToNumber(cell.getAttribute('data-image-position-x') ?? '0');
    const y = stringPercentToNumber(cell.getAttribute('data-image-position-y') ?? '0');
    const isLayoutLeft = cell.classList.contains('-image-left');

    this.$sliderMaskPosition.setImagePosition(x * 0.01, y * 0.01, 'focus', !isBackwards, isLayoutLeft ? 'layoutLeft' : 'layoutRight');
  }

  enterSlider() {
    if (!this.$sliderMaskPosition) {
      return;
    }

    this.lockSlider();

    this.$state.isOverview = false;
    this.$sliderMaskPosition.setMask(true);

    const firstCell = this.$cells[0];

    if (firstCell) {
      this.setMaskForCell(this.$cells[0]);

      setTimeout(() => {
        firstCell.classList.add('-active');
        firstCell.classList.add('-active-forwards');
      }, 100);
    }
  }

  leaveSlider() {
    if (!this.$sliderMaskPosition) {
      return;
    }

    this.$state.isOverview = true;
    this.$sliderMaskPosition.setImagePosition(0.5, 0.5, 'overview', false, 'center');
    this.$sliderMaskPosition.setMask(false);

    for (let i = 0; i < this.$cells.length; i += 1) {
      const c = this.$cells[i];

      c.classList.remove('-active');
      c.classList.remove('-active-back');
      c.classList.remove('-active-forwards');
    }
  }

  sliderMaskPosition() {
    const { $slidermask } = this;
    const $imageWrapper = $slidermask.querySelector('.slidermask > .imagewrapper');
    const $image = $slidermask.querySelector('.slidermask > .imagewrapper > .image');
    const $maskSvg = $slidermask.querySelector('.slidermask > .svg');

    if (!$slidermask || !$imageWrapper || !$image || !$maskSvg) {
      return null;
    }

    const responsiveMaskSizes = useResponsiveMaskSizes();

    const svg = {
      width: 2000,
      innerCircleWidth: 200,
    };

    const params = {
      svgScaleMax: 20,
      imageScaleOverview: 1,
      animationDuration: 0.75,
    };

    const state = {
      imageScaleFocus: 400,
      width: $slidermask.clientWidth,
      height: $slidermask.clientHeight,
      sizeInnerMask: 0,
      imagePosition: {
        x: 0.5,
        y: 0.5,
        scale: 1,
      },
      isMaskSet: false,
      maskPosition: {
        center: { x: 0.5, y: 0.5 },
        layoutLeft: { x: 0.2, y: 0.5 },
        layoutRight: { x: 0.8, y: 0.5 },
      },
      sizeCircle: 0,
      maskLayout: 'center',
    };

    gsap.set($maskSvg, {
      scale: params.svgScaleMax,
    });

    setState();

    window.addEventListener('resize', setState);

    return {
      setImagePosition,
      setMask,
    };

    function setState() {
      setMaskToResponsiveSize();

      state.width = $slidermask.clientWidth;
      state.height = $slidermask.clientHeight;
      state.sizeInnerMask = $slidermask.clientWidth * state.sizeCircle;

      setMaskPosition(state.maskPosition[state.maskLayout]);

      if (state.isMaskSet) {
        setMask(true);
      }
    }

    function setMaskToResponsiveSize() {
      const size = getCurrentWindowSize();
      const sizes = responsiveMaskSizes[size];

      state.imageScaleFocus = sizes.imageScaleFocus;
      state.sizeCircle = sizes.sizeCircle;

      state.maskPosition.center.x = sizes.center.positionX;
      state.maskPosition.center.y = sizes.center.positionY;

      state.maskPosition.layoutLeft.x = sizes.layoutLeft.positionX;
      state.maskPosition.layoutLeft.y = sizes.layoutLeft.positionY;

      state.maskPosition.layoutRight.x = sizes.layoutRight.positionX;
      state.maskPosition.layoutRight.y = sizes.layoutRight.positionY;
    }

    function setMaskLayout(layout) {
      state.maskLayout = layout;

      setMaskPosition(state.maskPosition[state.maskLayout]);
    }

    function setMask(show) {
      state.isMaskSet = show;
      const scale = show ? state.sizeInnerMask / svg.innerCircleWidth : params.svgScaleMax;

      setMaskPosition(state.maskPosition[state.maskLayout]);

      gsap.to($maskSvg, {
        scale,
      });
    }

    function scaleMaskOut() {
      return new Promise((resolve) => {
        gsap.to($maskSvg, {
          scale: params.svgScaleMax,
          duration: params.animationDuration,
          onComplete: resolve,
        });
      });
    }

    function scaleMaskIn() {
      return new Promise((resolve) => {
        gsap.to($maskSvg, {
          scale: state.sizeInnerMask / svg.innerCircleWidth,
          duration: params.animationDuration,
          onComplete: resolve,
        });
      });
    }

    async function setImagePosition(
      x,
      y,
      scale,
      withAnimation = false,
      layout = 'center',
    ) {
      state.imagePosition.x = x;
      state.imagePosition.y = y;
      state.maskLayout = layout;

      if (scale === 'focus') {
        state.imagePosition.scale = state.imageScaleFocus;
      } else {
        state.imagePosition.scale = params.imageScaleOverview;
      }

      if (withAnimation) {
        await scaleMaskOut();
        setMaskLayout(layout);

        scaleMaskIn();
      } else {
        setMaskLayout(layout);
      }

      gsap.to($image, {
        scale: state.imagePosition.scale,
        x: `${(x * 2 - 1) * (50 * state.imagePosition.scale) * -1}%`,
        y: `${(y * 2 - 1) * (50 * state.imagePosition.scale) * -1}%`,
        duration: params.animationDuration,
      });
    }

    function setMaskPosition(position) {
      const maskTopLeft = {
        x: (svg.width - state.width) * -0.5 - state.width * 0.5,
        y: (svg.width - state.height) * -0.5 - state.height * 0.5,
      };

      gsap.to($maskSvg, {
        x: maskTopLeft.x + state.width * position.x,
        y: maskTopLeft.y + state.height * position.y,
        duration: params.animationDuration,
      });

      const overflow = calculateOverflowPercent($image, $imageWrapper);

      const addedOverflowX = (state.imagePosition.x - 0.5)
        * overflow.overflowPercentX * state.imagePosition.scale;
      const addedOverflowY = (state.imagePosition.y - 0.5)
        * overflow.overflowPercentY * state.imagePosition.scale;

      gsap.to($imageWrapper, {
        x: `${(position.x - 0.5) * 100 - addedOverflowX}%`,
        y: `${(position.y - 0.5) * 100 - addedOverflowY}%`,
        duration: params.animationDuration,
      });
    }
  }
}

function calculateOverflowPercent(image, container) {
  const imageNaturalWidth = 1920;
  const imageNaturalHeight = 1578;

  const scaleX = container.clientWidth / imageNaturalWidth;
  const scaleY = container.clientHeight / imageNaturalHeight;

  const scale = Math.max(scaleX, scaleY);

  const displayedWidth = imageNaturalWidth * scale;
  const displayedHeight = imageNaturalHeight * scale;

  const overflowX = Math.max(0, displayedWidth - container.clientWidth);
  const overflowY = Math.max(0, displayedHeight - container.clientHeight);

  const overflowPercentX = (overflowX / container.clientWidth) * 100;
  const overflowPercentY = (overflowY / container.clientHeight) * 100;

  return {
    overflowPercentX,
    overflowPercentY,
  };
}

function stringPercentToNumber(value) {
  return Number(value.replace('%', ''));
}

function useResponsiveMaskSizes() {
  return {
    customXs: {
      imageScaleFocus: 2.95,
      sizeCircle: stringPercentToNumber('40%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('35%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('35%') * 0.01,
      },
    },
    xs: {
      imageScaleFocus: 2,
      sizeCircle: stringPercentToNumber('50%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('24%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('24%') * 0.01,
      },
    },
    sm: {
      imageScaleFocus: 2.95,
      sizeCircle: stringPercentToNumber('40%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('32%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('32%') * 0.01,
      },
    },
    md: {
      imageScaleFocus: 1.8,
      sizeCircle: stringPercentToNumber('35%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('22%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('78%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
    },
    lg: {
      imageScaleFocus: 1.5,
      sizeCircle: stringPercentToNumber('32%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('18%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('81%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
    },
    xl: {
      imageScaleFocus: 1.8,
      sizeCircle: stringPercentToNumber('30%') * 0.01,
      center: {
        positionX: stringPercentToNumber('50%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutLeft: {
        positionX: stringPercentToNumber('21%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
      layoutRight: {
        positionX: stringPercentToNumber('78%') * 0.01,
        positionY: stringPercentToNumber('50%') * 0.01,
      },
    },
  };
}

function getCurrentWindowSize() {
  if (window.matchMedia('(max-width: 575px) and (min-aspect-ratio: 1/1)').matches) {
    return 'customXs';
  }
  if (window.matchMedia('(max-width: 575px) and (max-aspect-ratio: 1/1)').matches) {
    return 'xs';
  }
  if (window.matchMedia('(max-width: 767px)').matches) {
    return 'sm';
  }
  if (window.matchMedia('(max-width: 991px)').matches) {
    return 'md';
  }
  if (window.matchMedia('(max-width: 1199px)').matches) {
    return 'lg';
  }

  return 'xl';
}
